import { createStore } from 'owa-satcheljs';
import type AccountConditionStore from './schema/AccountConditionStore';
import type AccountAuthState from './schema/AccountAuthState';
import type { IdentityKey } from 'owa-auth-types';

const defaultAccountConditionStore: AccountConditionStore = {
    accountAuthStates: new Map<IdentityKey, AccountAuthState>([]),
};

const getStore: () => AccountConditionStore = createStore<AccountConditionStore>(
    'accountConditionStore',
    defaultAccountConditionStore
);

export default getStore;
